import { FluidTableHeader } from '@lmig/fluid-core';

import { FluidTable } from '../fluid-table';

/**
 * Flattens all headers into a single array (if split data points exist, this will bring
 * them all to the same level in the array)
 * @param headers
 */
export const flattenHeaders = (headers: FluidTableHeader[]) => {
  return headers.reduce(
    (allHeaders: FluidTableHeader[], current: FluidTableHeader) => {
      if (!current.splitDataPoints) {
        allHeaders.push(current);
      } else {
        allHeaders = [
          ...allHeaders,
          ...flattenHeaders(current.splitDataPoints),
        ];
      }
      return allHeaders;
    },
    []
  );
};

/**
 * Updates a table header with a partial update. First checks if it is a split data point header, before finding
 * the appropriate nested header, and updating it / updating the header directly, then calling host.updateHeader to
 * update it on the host element.
 * @param host
 * @param header
 * @param update
 */
export const updateTableHeader = (
  host: Partial<FluidTable>,
  header: FluidTableHeader,
  update: Partial<FluidTableHeader>
): void => {
  if (header._isSplitHeader) {
    const parentHeader = getSplitDataPointParent(host._headers, header);
    const splitHeaderIdx = getSplitDataPointIndex(parentHeader, header);
    parentHeader.splitDataPoints[splitHeaderIdx] = {
      ...parentHeader.splitDataPoints[splitHeaderIdx],
      ...update,
    };
    host.updateHeader(parentHeader, {});
  } else {
    host.updateHeader(header, update);
  }
};

/**
 * Returns the parent header of a given split point header
 * @param headers
 * @param header
 */
export const getSplitDataPointParent = (
  headers: FluidTableHeader[],
  header: FluidTableHeader
): FluidTableHeader => {
  return headers.find((h) => h._headerId === header._parentHeaderId);
};

/**
 * Returns the array index of a given split point header
 * @param parentHeader
 * @param header
 */
export const getSplitDataPointIndex = (
  parentHeader: FluidTableHeader,
  header: FluidTableHeader
): number => {
  return parentHeader.splitDataPoints.findIndex(
    (s) => s.dataPath === header.dataPath
  );
};
